import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

export const useStyles = makeStyles((theme) => ({
  newSignatureContainer: {
    marginTop: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  saveSignatureCheckBox: {
    color: grey[600],
    marginTop: theme.spacing(2),
  },
  customLabel: {
    fontSize: "14px",
    fontWeight: 500,
  },
}));
